import laroute from '../../../../public/js/laroute';
import { provideVariables } from './index';

export default provideVariables('$laroute', laroute);
